export default "__VITE_ASSET__BIz5hr2G__"